
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "./baseApiClient";
import { logger } from "@/lib/logger";
import { AIStaffLevel } from "@/lib/types";

export interface SubscriptionPlan {
  priceId: string;
  name: string;
  price: number;
  period: 'monthly' | 'annual';
  features: string[];
  isPopular?: boolean;
  recommended?: boolean;
  level?: AIStaffLevel;
  billingCycle?: string; // Add the optional billingCycle property
}

export const subscriptionApiClient = {
  initiateCheckout: async (userId: string, businessId: string, priceId: string) => {
    try {
      logger.info({
        message: "Initiating payment checkout",
        context: { userId, businessId, priceId }
      });
      
      const { data, error } = await supabase.functions.invoke('stripe-payment', {
        body: {
          priceId,
          customerId: userId,
          businessId
        }
      });

      if (error) {
        throw new Error(`Payment initialization failed: ${error.message}`);
      }
      
      return data;
    } catch (error) {
      logger.error({
        message: "Error initiating payment",
        error: error instanceof Error ? error : new Error(String(error)),
        context: { userId, businessId, priceId }
      });
      throw error;
    }
  },
  
  cancelSubscription: async (businessId: string, subscriptionId: string) => {
    try {
      logger.info({
        message: "Cancelling subscription",
        context: { businessId, subscriptionId }
      });
      
      const { data, error } = await supabase.functions.invoke('stripe-subscription', {
        body: {
          action: 'cancel',
          businessId,
          subscriptionId
        }
      });

      if (error) {
        throw new Error(`Subscription cancellation failed: ${error.message}`);
      }
      
      // Clear subscription cache
      BaseApiClient.clearCache(`business:subscription:${businessId}`);
      
      return data;
    } catch (error) {
      logger.error({
        message: "Error cancelling subscription",
        error: error instanceof Error ? error : new Error(String(error)),
        context: { businessId, subscriptionId }
      });
      throw error;
    }
  },
  
  clearCache: () => {
    BaseApiClient.clearCache('subscription:');
  }
};
